import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import img from '../images/avatar.jpg'

export default class Header extends React.Component {
  componentDidMount() {
    window.addEventListener('load', () => {
      document.getElementsByClassName('is-loading')[0].className = ''
    })
  }

  render() {
    const captchaUrl = 'http://www.google.com/recaptcha/mailhide/d?k=018eKjJW_mvBwHO81HMwi1zQ=='
      + '&c=cz55lGAvBj2LG6bXFPu2mQ=='

    return (
      <div id="wrapper" className="is-loading">
        <Helmet>
          <noscript>
            {`
<style type="text/css">
/* Basic */
body:after {
  display: none; }
/* Main */
#main {
  transform: none !important;
  opacity: 1 !important; }
</style>
`}
          </noscript>
        </Helmet>

        <section id="main">
          <header>
            <span className="avatar"><img src={img} alt="" /></span>
            <h1>{config.authorName}</h1>
            <p>Platform Engineer<br />Tech Enthusiast</p>
          </header>

          <footer>
            <ul className="icons">
              <li><a href="https://www.linkedin.com/in/robertkopaczewski/" className="fa-linkedin">Twitter</a></li>
              <li><a href="https://github.com/23doors/" className="fa-github">Github</a></li>
              <li><a href={captchaUrl} className="fa-envelope" >Mail</a></li>
            </ul>
          </footer>
        </section>
        <footer id="footer">
          <ul className="copyright">
            <li>&copy; Robert Kopaczewski</li><li>Design: <a href="http://html5up.net">HTML5 UP</a></li>
          </ul>
        </footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../components/Identity.jsx